import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const Users = ({match}) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/profiles`}/>
      <Route path={`${match.url}/profiles`} component={asyncComponent(() => import('./routes/Profiles'))}/>
      <Route path={`${match.url}/settings`} component={asyncComponent(() => import('./routes/Settings'))}/>
      <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Users;